<script>
	// 폼 응답 1건 카드. 키:값을 세로로 쌓아 긴 내용도 안 잘리고 줄바꿈된다.
	// 메인 "응답" 탭(FormSubmissionsContext)과 미리보기 패널 "응답"(BlockResponsesPanel)에서 공용.
	export let row;
	export let formLabel = "";
	export let showForm = false;

	const entries = (o) => Object.entries(o || {});
	const parseDate = (v) => {
		const d = new Date(String(v ?? "").replace(" ", "T"));
		return isNaN(d.getTime()) ? null : d;
	};
	const fmt = (v) => {
		const d = parseDate(v);
		if (!d) return String(v ?? "");
		const p = (n) => String(n).padStart(2, "0");
		return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
	};
</script>

<div class="rc">
	<div class="rc-top">
		<span class="rc-time">{fmt(row.createdAt)}</span>
		{#if showForm && formLabel}<span class="rc-form" title={formLabel}>{formLabel}</span>{/if}
		<span class="rc-spacer" />
		{#if row.env === "preview"}
			<span class="rc-env test">테스트</span>
		{:else}
			<span class="rc-env prod">실사용</span>
		{/if}
	</div>
	<div class="rc-fields">
		{#each entries(row.values) as [k, v]}
			<div class="rc-f">
				<span class="rc-k">{k}</span>
				<span class="rc-v">{v}</span>
			</div>
		{/each}
	</div>
</div>

<style>
	.rc {
		border: 1px solid hsl(var(--sb-border));
		border-radius: 8px;
		padding: 10px 12px;
		background: hsl(var(--sb-card));
	}
	.rc-top {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;
	}
	.rc-time {
		font-size: 11.5px;
		color: hsl(var(--sb-muted-foreground));
		font-variant-numeric: tabular-nums;
		white-space: nowrap;
	}
	.rc-form {
		font-size: 11px;
		padding: 1px 7px;
		border-radius: 999px;
		background: hsl(var(--sb-muted));
		color: hsl(var(--sb-muted-foreground));
		max-width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.rc-spacer {
		flex: 1;
	}
	.rc-env {
		font-size: 10.5px;
		font-weight: 600;
		padding: 2px 8px;
		border-radius: 999px;
		white-space: nowrap;
	}
	.rc-env.prod {
		background: hsl(var(--sb-primary) / 0.12);
		color: hsl(var(--sb-primary));
	}
	.rc-env.test {
		background: hsl(var(--sb-muted));
		color: hsl(var(--sb-muted-foreground));
	}
	.rc-fields {
		display: flex;
		flex-direction: column;
		gap: 5px;
	}
	.rc-f {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: 10px;
		align-items: baseline;
	}
	.rc-k {
		font-size: 11.5px;
		font-weight: 600;
		color: hsl(var(--sb-muted-foreground));
		white-space: nowrap;
	}
	.rc-v {
		font-size: 13px;
		color: hsl(var(--sb-foreground));
		word-break: break-word;
		overflow-wrap: anywhere;
	}
</style>
